export default "__VITE_ASSET__2SYDOPzb__"